import React, { Component } from "react";
import { Layout } from "antd";

import LinestickerHeader from "../../components/linesticker-common/header";
import LinestickerContent from "../../components/linesticker-common/content";
import LinestickerFooter from "../../components/linesticker-common/footer";
import "./linesticker.css";
const { Header, Content, Footer } = Layout;

export default class Linesticker extends Component {
  render() {
    return (
      <Layout className="linesticker">
        <Header>
          <LinestickerHeader />
        </Header>
        <Content>
          <LinestickerContent />
        </Content>
        <Footer>
          <LinestickerFooter />
        </Footer>
      </Layout>
    );
  }
}
